import type { WithActiveBranchId } from '@app/api/shared';

export enum ClientFieldsEndpoints {
  GetClientFields = 'GetClientFields',
  GetClientFieldById = 'GetClientFieldById',
  CreateClientField = 'CreateClientField',
  EditClientField = 'EditClientField',
  DeleteClientField = 'DeleteClientField',
}

export interface ModelClientField {
  Id: number;
  Name: string | null;
  IsDeleted: boolean;
  /** Важное поле: показывается в окне записи и в карточке лида */
  IsImportant: boolean;
}

export type GetClientFieldsRequest = WithActiveBranchId;

export type GetClientFieldByIdRequest = WithActiveBranchId<{
  fieldId: number;
}>;

export type CreateClientFieldRequest = WithActiveBranchId<{
  data: ModelClientField;
}>;

export type EditClientFieldRequest = WithActiveBranchId<{
  data: ModelClientField;
}>;

export type DeleteClientFieldRequest = WithActiveBranchId<{
  fieldId: number;
}>;

export type GetClientFieldsResponse = ModelClientField[];
export type GetClientFieldByIdResponse = ModelClientField;
export type CreateClientFieldResponse = ModelClientField;
export type EditClientFieldResponse = ModelClientField;
export type DeleteClientFieldResponse = void;
